import IsNullOrUndefined from "../utils/ObjectUtils";
import FormatVat from "../utils/VatFormatter";
import {getPriceText} from "../utils/currencyFormatter";

export const PriceUtility = {

    calculateSectionTotalPriceIncVat: (section, vat) => {
        let sectionTotalPrice = 0;

        section.categories.forEach(category => {
            if (category.disabled) return;

            const currentFeature = category.features.find(
                feature => feature.id === category.selected_feature
            );

            if (
                currentFeature &&
                currentFeature.price !== undefined &&
                currentFeature.price !== 'ND'
            ) {
                const price = parseFloat(currentFeature.price);
                if (!isNaN(price)) {
                    const vatRate = PriceUtility.getFeatureVatValue(currentFeature.id, vat);
                    const priceWithVat = price + price * vatRate / 100;
                    sectionTotalPrice += priceWithVat;
                }
            }
        });

        return sectionTotalPrice;
    },

    calculateFeaturePrice: (feature, vat) => {
        let featureTotalPrice = 0;

        if (!IsNullOrUndefined(feature)) {
            const featurePrice = parseFloat(feature.price);

            if (!isNaN(featurePrice)) {
                if(IsNullOrUndefined(feature.quantity)) {
                    featureTotalPrice += featurePrice;
                } else {
                    featureTotalPrice += featurePrice * feature.quantity.current_value;
                }
            }
        }

        if (vat.vat_breakdown_disabled) {
            featureTotalPrice = featureTotalPrice + featureTotalPrice * PriceUtility.getFeatureVatValue(feature.id, vat) / 100;
        }

        return featureTotalPrice;
    },
    calculateTotalPrice: (categories, vat) => {
        let total = 0;
        categories.forEach((category) => {
            if (!category.disabled) {
                category.features.forEach(feature => {
                    if (category.selected_feature === feature.id && !isNaN(feature.price)) {
                        total += PriceUtility.calculateFeaturePrice(feature, vat);
                    }
                });
            }
        });

        return total;
    },

    getFeatureFormattedPrice: (feature, vat) => {
        let featureTotalPrice = 0;

        if (!IsNullOrUndefined(feature)) {
            const featurePrice = parseFloat(feature.price);

            if (!isNaN(featurePrice)) {
                if (IsNullOrUndefined(feature.quantity)) {
                    featureTotalPrice += featurePrice;
                } else {
                    featureTotalPrice += featurePrice * feature.quantity.current_value;
                }

                if (vat.vat_breakdown_disabled) {
                    featureTotalPrice = featureTotalPrice + featureTotalPrice * PriceUtility.getFeatureVatValue(feature.id, vat) / 100;
                }
            }
        }

        if (featureTotalPrice === 0) return '';

        return getPriceText(featureTotalPrice, true);
    },

    getFeatureFormattedVatValue: (feature, vat) => {
        if (isNaN(feature.price) || parseFloat(feature.price) === 0 || !vat?.vat_enabled) return '';

        const override = vat.vat_overrides?.find(o => o.feature_id === feature.id);
        return `${FormatVat(override ? override.override_vat : vat.global_vat)} IVA`;
    },

    getFeatureVatValue: (featureId, vat) => {
        if (!vat?.vat_enabled) return 0;

        const override = vat.vat_overrides?.find(o => o.feature_id === featureId);
        return override ? override.override_vat / 100 : vat.global_vat / 100;
    },

    calculateFeatureVatValue: (featureId, price, vat) => {
        const rate = PriceUtility.getFeatureVatValue(featureId, vat) / 100;
        return price * rate;
    },

    calculateFeaturePriceIncVat: (feature, vat) => {
        if (isNaN(feature.price)) return 0;

        const price = parseFloat(feature.price);
        const vatRate = PriceUtility.getFeatureVatValue(feature.id, vat) / 100;

        return price + price * vatRate;
    },

    calculateVatValue: (categories, vat) => {
        let vatValue = 0;

        categories.forEach((category) => {
            if (!category.disabled) {
                category.features.forEach(feature => {
                    if (category.selected_feature === feature.id && !isNaN(feature.price)) {
                        const price = parseFloat(feature.price);
                        vatValue += PriceUtility.calculateFeatureVatValue(feature.id, price, vat);
                    }
                });
            }
        });

        return vatValue;
    },

    calculateTotalPriceIncVat: (categories, vat) => {
        let total = 0;

        categories.forEach((category) => {
            if (!category.disabled) {
                category.features.forEach(feature => {
                    if (category.selected_feature === feature.id && !isNaN(feature.price)) {
                        const price = parseFloat(feature.price);
                        const vatAmount = PriceUtility.calculateFeatureVatValue(feature.id, price, vat);
                        total += price + vatAmount;
                    }
                });
            }
        });

        return total;
    },

    getPublicFeatureFormattedPrice: (feature, vat) => {
        const featurePrice = parseFloat(feature.price);

        if (isNaN(featurePrice) ) {
            return feature.price;
        }

        return PriceUtility.getFeatureFormattedPrice(feature, vat);
    }

};
